import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  TEOLoader,
  Switch,
  RadioGroupActive,
  InputText,
  Button,
} from '@teo/components';
import {
  Balloon,
  Certificate,
  PersonInfo,
  StartFlag,
} from '@teo/components/icons';
import UploadMainImage from '@/components/UploadMainImage/UploadMainImage';
import MotivationalLP from './MotivationalLP';
import CertificatesLP from './CertificatesLP';
import EditCertificate from '../ModalLP/EditCertificate';

const SettingsMilestone = ({
  trainingDetail,
  handleChangeTraining,
  setTypeOfTraining,
  typeOfTraining,
  title,
  authUser,
}) => {
  const { t } = useTranslation();

  const [image, setImage] = useState(
    trainingDetail?.trainingPicture
      ? trainingDetail?.trainingPicture
      : '/assets/images/LearnPath.png'
  );
  const [showProgress, setShowProgress] = useState(
    trainingDetail?.showProgress
  );
  const [loadingImgSpinner, setLoadingImgSpinner] = useState(false);
  const [functionName, setFunctionName] = useState(
    trainingDetail?.functionName || ''
  );
  const [titleCertificate, setTitleCertificate] = useState(
    trainingDetail?.titleCertificate || ''
  );
  const [modulesCertificate, setModulesCertificate] = useState(
    trainingDetail?.modulesCertificate || []
  );
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);

  const changeImage = (value) => {
    setImage(value);
    handleChangeTraining({ trainingPicture: value });
  };

  return (
    <>
      <div className="border-t p-5">
        <h4 className="mb-3 text-base">
          {t('pages.learning_path.settings_label')}
        </h4>
        <div className=" mt-6 w-full">
          <label className="mb-1 block text-sm font-semibold text-black">
            {t('pages.learning_path.settings.image')}
          </label>
          {loadingImgSpinner && (
            <div className="mx-auto flex justify-center p-10">
              <TEOLoader
                loaderSrc="/images/TEOloader.gif"
                className="w-[110px]"
              />
            </div>
          )}
          <UploadMainImage
            setUploadLogo={changeImage}
            uploadLogo={image}
            courseImg={true}
            learningPathHomeImg={true}
            setLoadingImgSpinner={setLoadingImgSpinner}
            loadingImgSpinner={loadingImgSpinner}
          />
        </div>
        <div className="mt-6">
          <label className="mb-1 block text-sm font-semibold text-black">
            {t('pages.learning_path.settings.milestone_type')}
          </label>
          <RadioGroupActive
            onChange={(value) => {
              setTypeOfTraining(value);
              handleChangeTraining({
                typeOfTraining: value,
                hasCertificate: value == 'certificate',
              });
            }}
            value={typeOfTraining}
            gap="gap-2"
          >
            <RadioGroupActive.Option
              value="motivator"
              hiddenRadio
              Icon={Balloon}
            >
              {t('pages.learning_path.settings.motivator')}
            </RadioGroupActive.Option>
            {authUser?.useCertificates && (
              <RadioGroupActive.Option
                value="certificate"
                hiddenRadio
                Icon={Certificate}
              >
                {t('pages.learning_path.settings.certificate')}
              </RadioGroupActive.Option>
            )}
            <RadioGroupActive.Option
              value="function"
              hiddenRadio
              Icon={PersonInfo}
            >
              {t('pages.learning_path.settings.function')}
            </RadioGroupActive.Option>
            <RadioGroupActive.Option
              value="endpoint"
              hiddenRadio
              Icon={StartFlag}
            >
              {t('pages.learning_path.settings.endpoint')}
            </RadioGroupActive.Option>
          </RadioGroupActive>
        </div>
        <div className="mt-6 flex flex-row items-center gap-4 rounded-lg border border-grey-02 p-4">
          <div>
            <Switch
              checked={showProgress}
              onChange={(isCheck) => {
                setShowProgress(isCheck);
                handleChangeTraining({ showProgress: isCheck });
              }}
            />
          </div>
          <div>
            <h4 className="font-normal">
              {t('pages.learning_path.settings.show_progress')}
            </h4>
          </div>
        </div>
        {typeOfTraining === 'function' && (
          <div className="mt-6">
            <label className="mb-1 block text-sm font-semibold text-black">
              {t('pages.learning_path.settings.function_name')}
            </label>
            <InputText
              value={functionName}
              onChange={(e) => setFunctionName(e.currentTarget.value)}
              onBlur={() =>
                handleChangeTraining({ functionName: functionName })
              }
              className="mb-2"
              placeholder={t(
                'pages.learning_path.settings.placeholder_function_name'
              )}
            />
          </div>
        )}
      </div>
      {typeOfTraining === 'certificate' && authUser?.useCertificates && (
        <div className=" border-t px-5 py-5">
          <label className="mb-1 block text-sm font-semibold text-black">
            {t('pages.learning_path.settings.certificate')}
          </label>
          <CertificatesLP
            setIsOpenEditModal={setIsOpenEditModal}
            titleCertificate={titleCertificate || title}
            modulesCertificate={modulesCertificate}
          />
        </div>
      )}
      <div className=" border-t px-5 py-5">
        <label className="mb-1 block text-sm font-semibold text-black">
          {t('pages.learning_path.settings.motivational_message')}
        </label>
        <MotivationalLP
          trainingDetail={trainingDetail}
          handleChangeTraining={handleChangeTraining}
        />
      </div>
      {isOpenEditModal && (
        <EditCertificate
          onClose={() => setIsOpenEditModal(false)}
          setTitleCertificate={setTitleCertificate}
          titleCertificate={titleCertificate}
          setModulesCertificate={setModulesCertificate}
          modulesCertificate={modulesCertificate}
          handleChangeTraining={handleChangeTraining}
        />
      )}
    </>
  );
};
export default SettingsMilestone;
